export { RovoAnnouncementSplashModalWrapper as RovoAnnouncementSplashModal } from '../src/RovoAnnouncementSplashWrapper.tsx';
